const endpoints = {
  auth: {
    login: 'auth/tokens',
    forgotPassword: 'auth/forgot-passwords',
    resetPassword: 'auth/reset-passwords',
    logout: 'auth/logout',
    createPassword: 'auth/password-creations',
    emailVerification: 'auth/email-verifications',
    permissions: 'auth/me/permissions',
  },
  billing: {
    serviceAgreement: {
      serviceAgreement: 'service-agreements',
      serviceAgreementById: '/service-agreements/{id}',
    },
    serviceRates: {
      serviceRates: '/service-rates',
      serviceRatesByServiceAgreement: '/service-rates/service-agreements',
      serviceRatesHistoriesByServiceAgreeementId: '/service-rates/service-agreement/{serviceAgreementId}/histories',
    },
    surcharges: {
      surcharges: '/surcharges',
    },
  },
  common: {
    roles: '/roles',
    districts: '/districts',
    regions: '/regions',
    routes: '/routes',
  },
  customers: {
    customers: 'customers',
    customerById: 'customers/{customerId}',
    customersAccount: 'accounts',
    customerAccountById: 'accounts/{customerId}',
  },
  devices: {
    concentrators: {
      concentrators: 'concentrators',
      concentratorById: 'concentrators/{concentratorId}',
      concentratorHistoriesById: 'concentrators/{concentratorId}/histories',
      concentratorMeterBulklink: 'concentrators/{concentratorId}/meters/bulks',
      concentratorMeterBulkUnlink: 'concentrators/{concentratorId}/meters/dissociations',
      downloadMeters: 'concentrators/{concentratorId}/meters/exports',
      metersByConcentratorId: 'concentrators/{concentratorId}/meters',
      resetGPRS: 'concentrators/{concentratorId}/gprs-resets',
      updateConcentratorIp: 'concentrators/{concentratorId}/ip-alterations',
      updateClockCalibration: 'concentrators/{concentratorId}/clock-calibrations',
    },
    concentratorStatus: {
      concentratorStatus: 'concentrator-statuses',
    },
    meters: {
      meters: 'meters',
      meterById: 'meters/{meterId}',
      meterByMeterNumber: 'meters/{meterNumber}/meter-numbers',
      meterCsvUploads: 'meters/csv-uploads',
      meterValveOpening: 'meters/{meterNumber}/valve-openings',
      meterValveClosing: 'meters/{meterNumber}/valve-closings',
      meterReadingFromTCP: 'meters/{meterId}/tcp-meter-readings',

      // meter details
      meterBrands: 'meter-brands',
      meterInstallStages: 'meter-install-stages',
      meterModels: 'meter-models',
      meterSizes: 'meter-sizes',
      meterStates: 'meter-states',
      meterStatus: 'meter-statuses',
      meterTypes: 'meter-types',
      meterReadings: 'meters/{meterId}/readings',
      meterInitialFinalReadings: 'meters/{meterId}/reading-initials-finals',
      meterInstallationHistory: 'meters/{meterId}/installation-history',
      meterMappedInstallationHistory: 'meters/{meterId}/mapped-installation-history',
      meterOnlineHistory: 'meters/{meterId}/online-history',
      meterAddressHistory: 'meters/{meterId}/address-history',
    },
    phones: {
      phones: 'user-phones',
      phoneById: 'user-phones/{phoneId}',
      phoneHistoriesById: 'user-phones/{phoneId}/histories',
      phoneStatuses: 'user-phone-statuses',
      phoneModels: 'user-phone-models',
    },
  },
  payments: {
    receievedPayments: {
      gwclPaypoint: 'payments/gwcl-paypoint',
      gwclPaypointSummary: 'payments/gwcl-paypoint-summary',
      thirdPartyPaypoint: 'payments/third-party-paypoint',
      thirdPartyPaypointSummary: 'payments/third-party-paypoint-summary',
      electronic: 'payments/electronic',
      electronicSummary: 'payments/electronic-summary',
    },
  },
  user: {
    users: 'users',
    userById: 'users/{userId}',
    usersActivation: 'users/activations',
    userActivationById: 'users/{userId}/activations',
    userHistoriesById: 'users/{userId}/activities',
    technicians: 'technicians',
    technicianById: 'technicians/{technicianId}',
  },
};

export default endpoints;
